import ScheduleIcon from '@mui/icons-material/Schedule';
import { makeStyles } from 'tss-react/mui';
import { momentParse, dateAndTimeRange } from '../../utils/time';
import InlineMarkdown from '../inline-markdown';
import type { Event } from '../../types/Event';

const useStyles = makeStyles()((theme) => ({
  time: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  scheduleIcon: {
    flexShrink: 0,
    marginRight: theme.spacing(0.5),
  },
  details: {
    fontStyle: 'italic',
  },
}));

type Props = {
  event?: Event;
};

const EventDate = ({ event }: Props) => {
  const { classes } = useStyles();

  if (!event.startAt) {
    return <div>TBD</div>;
  }

  const startAt = momentParse(event.startAt, event.timezone);
  const endAt = event.endAt ? momentParse(event.endAt, event.timezone) : null;
  const details = event.startAtDetails;

  return (
    <div className={classes.time}>
      <ScheduleIcon className={classes.scheduleIcon} />
      <div>
        <time
          dateTime={startAt.toString()}
          title={startAt.format('dddd, MMMM Do, YYYY h:mm a')}
        >
          {dateAndTimeRange(startAt, endAt)}
        </time>
        {details && (
          <div className={classes.details}>
            <InlineMarkdown>{details}</InlineMarkdown>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventDate;
